import {Show, Text, VStack} from 'platform/foundation';

import {Nullish, TestIdProps} from 'shared/web';

import i18n from '../../i18n/i18n';
import {isCebiaWorkspace} from '../../utils/isCebiaWorkspace';
import {formatInspectionComment} from './formatInspectionComment';

interface FormattedCommentProps extends TestIdProps {
  comment?: string | Nullish;
}

const PARAGRAPH_SPACING = 3;

export function FormattedComment(props: FormattedCommentProps) {
  const paragraphs = formatInspectionComment(
    props.comment ?? '',
    i18n.resolvedLanguage,
    isCebiaWorkspace()
  );

  return (
    <VStack spacing={PARAGRAPH_SPACING} data-testid={props['data-testid']}>
      {paragraphs.map((paragraph, index) => (
        // eslint-disable-next-line react/no-array-index-key -- Pre-existing violation
        <Text key={index} size="base" color="secondary" overflowWrap="anywhere" preWrap>
          <Show when={paragraph.header}>
            <strong>{paragraph.header}</strong>
          </Show>
          {paragraph.body}
        </Text>
      ))}
    </VStack>
  );
}
